import { DataBean } from "../DataBean";

export class FixedAssetItemRevaluation extends DataBean {


    public async getFixedAssetItemRevaluationCatalog(idItem:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemRevaluationCatalog_Number", [idItem]);
    }
    
}